import { BlockList } from '@zillow/cms-blocks';
import React from 'react';

import { PostsTemplate } from '../../../components/PostsTemplate';
import TermHero from '../../../components/TermHero/TermHero';
import { buildPrimaryTermPage } from '../../../util/buildPrimaryTermPage';
import { LearnLayout } from '../[[...slug]]';

const CategoryPageContent = ({ term, initialPage }) => (
    <PostsTemplate
        posts={term.posts}
        initialPage={initialPage}
        hero={
            <TermHero
                total={term.posts?.total}
                description={term.description}
                name={term.name}
            />
        }
        sidebar={
            term.sidebar ? (
                <BlockList blocks={term.sidebar?.blocks || []} />
            ) : null
        }
        footer={term.footer}
        archiveCategory={term.id}
        baseLink={term.link}
    />
);

const { getStaticProps, getStaticPaths, WrappedPage } =
    await buildPrimaryTermPage({
        basePath: '/learn/category',
        site: 'LEARN',
        taxonomy: 'CATEGORY',
        LayoutComponent: LearnLayout,
        ContentComponent: CategoryPageContent,
        additionalLayoutProps: {
            isBlog: true,
        },
    });

export { getStaticProps, getStaticPaths };
export default WrappedPage;
